import React, { useState } from 'react'
 
 
import TrainingAttendanceList from './TrainingAttendanceList';
import TrainingAttendanceForm from './TrainingAttendanceForm';

const TrainingAttendance= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <TrainingAttendanceForm addForm={setFromIsShown} update={upData} />
        ) : (
          <TrainingAttendanceList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default TrainingAttendance